import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { Col, Row } from "@/app/components/lib/my-bootstrap";
import { useTranslation } from "@/hooks/localization/useTranslations";
import InfoIcon from "./InfoIcon";

type TProps = {
  onSignIn: () => void;
  onRegister: () => void;
};

const CartAuthSection: React.FC<TProps> = ({ onRegister, onSignIn }) => {
  const t = useTranslation();
  return (
    <Row>
      <div className="pb-2 p-0">
        <InfoIcon /> {t.You_need_to_sign_in_firsts}
      </div>
      <Col className=" col-6">
        <CustomButton
          type={BtnTypes.neutral}
          size={BtnSizes.large}
          radius={BtnRadius.small}
          onClick={onRegister}
          fullWidth
          className="cart-button-register"
        >
          {t.register}
        </CustomButton>
      </Col>

      <Col className="col-6">
        <CustomButton
          type={BtnTypes.primary}
          size={BtnSizes.large}
          radius={BtnRadius.small}
          onClick={onSignIn}
          fullWidth
        >
          {t.sign_in}
        </CustomButton>
      </Col>
    </Row>
  );
};

export default CartAuthSection;
